import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INDENT_UNIT = 24;
export function SelectableTeamRow({
  teamName,
  depth,
  checked,
  onChange,
  hasChildren = false,
  isExpanded = false,
  onToggleExpand,
  isFirst = false
}) {
  const handleChange = e => {
    onChange(e.target.checked);
  };
  return /*#__PURE__*/_jsx(View, {
    paddingBlock: "400",
    paddingInline: "600",
    borderBlockStartWidth: isFirst ? undefined : '100',
    borderBlockStartColor: isFirst ? undefined : 'border-core-subtle',
    borderBlockStartStyle: isFirst ? undefined : 'solid',
    cursor: hasChildren ? 'pointer' : undefined,
    onClick: hasChildren ? onToggleExpand : undefined,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Flex, {
        inlineSize: `${(depth + 1) * INDENT_UNIT}px`,
        flexShrink: 0,
        alignItems: "center",
        justifyContent: "end",
        children: hasChildren && /*#__PURE__*/_jsx(IconButton, {
          size: "extra-small",
          use: "transparent",
          onClick: e => {
            e.stopPropagation();
            onToggleExpand === null || onToggleExpand === void 0 || onToggleExpand();
          },
          "aria-label": isExpanded ? I18n.text('app-governance-lib.installPermissions.teamRow.collapse') : I18n.text('app-governance-lib.installPermissions.teamRow.expand'),
          children: isExpanded ? /*#__PURE__*/_jsx(DownIcon, {}) : /*#__PURE__*/_jsx(RightIcon, {})
        })
      }), /*#__PURE__*/_jsx(View, {
        flex: 1,
        minInlineSize: "0",
        paddingInlineEnd: "300",
        children: /*#__PURE__*/_jsx(TruncateString, {
          textOverflow: "ellipsis",
          children: /*#__PURE__*/_jsx("b", {
            children: teamName
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        flexShrink: 0,
        onClick: e => e.stopPropagation(),
        children: /*#__PURE__*/_jsx(Toggle, {
          size: "extra-small",
          checked: checked,
          onChange: handleChange,
          "aria-label": teamName
        })
      })]
    })
  });
}